// extracted by mini-css-extract-plugin
module.exports = {"rotation":"GraphCard_rotation__SPlpn"};